import React from "react";
import { useLocation } from "react-router-dom";
import { LinkButton } from "components/haven-design";

const ProcessUpdateSuccess: React.FC = () => {
  const location = useLocation() as unknown as { state?: { enqueued?: boolean } };
  const enqueued = location?.state?.enqueued;
  return (
    <div className="text-center">
      <img
        src="https://hc-images2.s3.amazonaws.com/tada.png"
        style={{ maxWidth: 80, maxHeight: 80, marginBottom: 30 }}
      />

      <div style={{ fontSize: 18 }}>
        {enqueued ? (
          "Messages scheduled to send."
        ) : (
          "All Done!"
        )}
      </div>

      <LinkButton to="/dash/manager/lists" color="primary" size="S" className="margin-top-xl">
        Back to Dashboard
      </LinkButton>
    </div>
  );
};

export default ProcessUpdateSuccess;
